/// <reference types="sharepoint" />
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AppConfig } from './app.config';
import { Observable, BehaviorSubject } from 'rxjs';
import { GlobalServices } from './global.service';
import { tap, map } from 'rxjs/operators';
import { Languages } from '../models/enums.model';
import { AdminUser } from 'src/app/front-user/shared/models/user.model';

@Injectable({ providedIn: 'root' })
export class HttpServices {

  private _baseApiUrl = AppConfig.settings.apiServer.apiPath;
  // public headers: HttpHeaders;
  private adminUser: AdminUser = new AdminUser();
  public httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

 // public httpOptions = new HttpHeaders({'Content-Type':'application/json; charset=utf-8','CurrentAdminEmail': this.adminUser.Email});

  constructor(public http: HttpClient) {
    if (sessionStorage.getItem('AdminUserData')) {
      this.adminUser = <AdminUser>(JSON.parse(sessionStorage.getItem('AdminUserData')));
      this.httpOptions.headers = this.httpOptions.headers.append('CurrentAdminEmail', this.adminUser.Email);
      this._baseApiUrl = AppConfig.settings.apiServer.AdminSite + this._baseApiUrl;
    }
    else {
      this._baseApiUrl = AppConfig.settings.apiServer.PublicSite + this._baseApiUrl;
    }

  if (_spPageContextInfo.currentUICultureName == "ar-SA")
    {
      this.httpOptions.headers = this.httpOptions.headers.append('SiteLanguage', 'ar');
    }
    else
    {
      this.httpOptions.headers = this.httpOptions.headers.append('SiteLanguage', 'en');
    }
        // this.httpOptions.headers = this.httpOptions.headers.append('SiteLanguage', 'en');
    // this.httpOptions.headers = this.httpOptions.headers.append('SiteLanguage', 'ar');
  }
  /*get(url: string) {
     return this.http.get<any>(this._baseApiUrl + url, httpOptions);
   }*/

  get(url: string): Observable<any> {
    // this.showLoader();
    return this.http.get<any>(this._baseApiUrl + url, this.httpOptions);
  }
  post(url: string, entity: any) {
    return this.http.post<any>(this._baseApiUrl + url, entity, this.httpOptions);
  }
  put(url: string, id: number, entity: any) {
    return this.http.put(this._baseApiUrl + url + `/${id}`, entity);
  }
  delete(url: string) {
    return this.http.delete(this._baseApiUrl + url);
  }
}

